/**
 * システム関連のイベントリスナー
 * クエリとナビゲーション関連のイベント処理を管理
 */

import { NAVIGATION_EVENTS, QUERY_EVENTS } from "@/lib/events/constants";
import { addEventListener } from "@/lib/events/helpers";
import type { NavigationHistoryBackEventDetail } from "@/lib/events/types";

/**
 * システム関連のイベントリスナーを初期化
 */
export const initializeSystemEventListeners = () => {
  // クエリ関連イベントリスナー
  const handleQueryInvalidateActive = () => {
    import("@/lib/queryClient").then(({ queryClient }) => {
      queryClient.invalidateQueries({
        refetchType: "active",
      });
    });
  };

  // ナビゲーション関連イベントリスナー
  const handleNavigationHistoryBack = (
    event: CustomEvent<NavigationHistoryBackEventDetail>,
  ) => {
    const { detail } = event;
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = detail.fallbackUrl;
    }
  };

  // イベントリスナーを登録
  addEventListener(QUERY_EVENTS.INVALIDATE_ACTIVE, handleQueryInvalidateActive);
  addEventListener(NAVIGATION_EVENTS.HISTORY_BACK, handleNavigationHistoryBack);
};
